import React from 'react';
import { StopCircle, User, Calendar } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { selectVendorData } from '../vendormasters/store/selectors';
import { selectStatuses } from '../../core/redux/status/selectors';
import { selectPOFilters } from './store/selectors';
import { actions as poActions, fetchPOsWithFilters } from './store/slice';
import { actions as vendorActions } from '../vendormasters/store/slice';
import { Link } from 'react-router-dom';
import { useTransformOptions } from 'Core/hooks';

const { setStatus, setOrderDate } = poActions;
const { setVendor } = vendorActions;

const POFilter = () => {
  const dispatch = useDispatch();
  const vendors = useSelector(selectVendorData) || [];
  const statuses = useSelector(selectStatuses) || [];
  const {
    vendor: selectedVendor,
    status: selectedStatus,
    orderDate,
  } = useSelector(selectPOFilters);

  // Get vendor options for dropdown
  const vendorOptions = useTransformOptions(
    vendors,
    'id',
    'vendorName',
    '0',
    'Select Vendor',
  );

  // Get status options for dropdown
  const statusOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const handleVendorChange = selected => {
    dispatch(setVendor(selected));
  };

  const handleStatusChange = selected => {
    dispatch(setStatus(selected));
  };

  const onSearch = () => {
    dispatch(fetchPOsWithFilters());
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
          <div className="col-lg-4 col-sm-6 col-12">
            <div className="input-blocks">
              <User className="info-img" />
              <Select
                options={vendorOptions}
                value={selectedVendor}
                onChange={handleVendorChange}
                className="img-select"
                classNamePrefix="react-select"
                placeholder="Choose Vendor"
              />
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <StopCircle className="info-img" />
              <Select
                className="img-select"
                options={statusOptions}
                value={selectedStatus}
                onChange={handleStatusChange}
                classNamePrefix="react-select"
                placeholder="Choose Status"
              />
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <Calendar className="info-img" />
              <input
                type="date"
                className="form-control"
                value={orderDate || ''}
                onChange={e => dispatch(setOrderDate(e.target.value))}
                placeholder="Order Date"
              />
            </div>
          </div>

          <div className="col-lg-4 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <Link className="btn btn-filters ms-auto" onClick={onSearch}>
                {' '}
                <i data-feather="search" className="feather-search" /> Search{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default POFilter;
